// see https://github.com/orgs/vuejs/discussions/11798
/* eslint-disable @typescript-eslint/no-unsafe-return */
import { type RouteRecordRaw } from 'vue-router';
import { Navigation } from '@/router/navigation';
import { requireLoggedIn } from '@/router/guards/require-logged-in';
import { initNavAreaMyArea } from '@/router/guards/init-nav-area';
import { setNavAreaSwitchEnd, setNavAreaSwitchStart } from './guards/set-nav-area-switch';
import { requirePermission } from '@/router/guards/require-permission.ts';
import { PermissionName } from '@containex/portal-backend-dto';

export const accountContentContainerRoutes: RouteRecordRaw = {
    path: 'account',
    component: async () => import('../account/views/AccountContentContainerRouterView.vue'),
    beforeEnter: [setNavAreaSwitchStart, requireLoggedIn, initNavAreaMyArea, setNavAreaSwitchEnd],
    children: [
        // For backward compatibility, redirect old order confirmation detail route to the new one
        {
            path: 'order-confirmations/:id',
            redirect: (to) => ({
                ...to,
                name: Navigation.OrderConfirmationDetail,
            }),
        },
        {
            path: 'order-confirmations/detail/:id',
            name: Navigation.OrderConfirmationDetail,
            props: true,
            component: async () => import('../account/views/OrderConfirmationContentContainerDetailView.vue'),
            beforeEnter: [requirePermission(PermissionName.ORDERCONFIRMATIONS_VIEW)],
        },
    ],
};
